import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const TestimonialList = [
  {
    author: 'Julien',
    company: 'E3D Environnement',
    description:
      "Prestataire très motivé, disponible et flexible. Ca a été un vrai plaisir de travailler avec lui de bout en bout, et son rendu était à la hauteur du reste.",
  },
  {
    author: 'Antoine',
    company: 'Comdata',
    description:
      "Paul est un excellent développeur, la mission s'est déroulée parfaitement de A à Z. Efficace, curieux et à l'écoute, réactif, communiquant, Paul vise l'excellence dans ce qu'il va délivrer.",
  },
  {
    author: 'Mehdi',
    company: 'Tagether',
    description:
      "Respecte les délais, est à l'écoute et fourni un travail de qualité. Je le recommande si vous avez des projets en React Native !",
  },
  {
    author: 'William',
    company: 'Arpejio',
    description:
      "Paul n'a de crédo que le travail bien fait. Il est pointu, véritablement compétent et sait solutionner rapidement des problématiques complexes. C'est quelqu'un de confiance qui est passionné par ce qu'il entreprend. Je le recommande très vivement et j'apprécierais de travailler de nouveau avec lui !",
  },
  {
    author: 'Gregory',
    company: 'ComAgenda',
    description:
      "Paul est parvenu à suivre nos exigences et à délivrer plus que nos attentes. Il est clair que via ce biais nous souhaitons le recommander et surtout le remercier. [...] Un grand merci Paul, vous vous êtes montré durant toute la durée de notre projet, patient, intelligent, étonnant et surtout très persévérant.",
  },
];

class Testimonial extends Component {
  state = {
    selectedIndex: 0,
  };

  goTo = (index) => {
    const total = TestimonialList.length;
    this.setState({ selectedIndex: (index + total) % total });
  };

  render() {
    const { selectedIndex } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-12">
            <Tabs
              selectedIndex={selectedIndex}
              onSelect={(index) => this.setState({ selectedIndex: index })}
            >
              {TestimonialList.map((value, index) => (
                <TabPanel key={index}>
                  <div className="rn-testimonial-content text-center">
                    <div className="inner">
                      <p>{value.description}</p>
                    </div>
                    <div className="author-info">
                      <h6>
                        <span>{value.author} </span> - {value.company}
                      </h6>
                    </div>
                  </div>
                </TabPanel>
              ))}

              <div className="testimonial-nav-wrapper">
                <button
                  type="button"
                  className="testimonial-nav-arrow"
                  aria-label="Témoignage précédent"
                  onClick={() => this.goTo(selectedIndex - 1)}
                >
                  &#8249;
                </button>

                <TabList className="testimonial-tab-nav">
                  {TestimonialList.map((value, index) => (
                    <Tab key={index}>{value.company}</Tab>
                  ))}
                </TabList>

                <button
                  type="button"
                  className="testimonial-nav-arrow"
                  aria-label="Témoignage suivant"
                  onClick={() => this.goTo(selectedIndex + 1)}
                >
                  &#8250;
                </button>
              </div>
            </Tabs>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Testimonial;
